import { Select } from '@chakra-ui/react'
import { UseFormReturn } from 'react-hook-form'

import { FormItem } from 'components/miscellaneous'
import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import { CUSTOM_FORM_ENTITY_KIND_OPTIONS } from 'components/tools/CustomForm/constants'

type QuestionProps = {
  formMethods: UseFormReturn<CustomFormQuestion>
}

export default function EntityKindOptions({ formMethods }: QuestionProps) {
  return (
    <FormItem isRequired label="Tipo de registro">
      <Select placeholder="Selecione um tipo de registro" {...formMethods.register('entity')}>
        {CUSTOM_FORM_ENTITY_KIND_OPTIONS.map(({ label, value }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Select>
    </FormItem>
  )
}
